import {Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {Colaborador} from '@modelo/catalogo/Colaborador.model';

import {ColaboradorFormComponent} from './colaboradorForm.component';
import {ColaboradorLayoutComponent} from './layout/colaborador_layout.component';

@Component(
    {
        selector: 'colaborador',
        templateUrl: './colaborador.template.html',
        styleUrls: ['./colaborador.component.scss']
    })

export class ColaboradorComponent implements AfterViewInit {
    dataTable!: Array<any>;
    SelEstatusColaborador: any[];

    consulta!: boolean;
    @ViewChild("containerFormulario", {read: ViewContainerRef}) containerFormulario!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
        this.uriApi = "configuracionrh/colaborador/buscar";
        this.SelEstatusColaborador = [];
        this.GenerarFiltros()
    }

    ngAfterViewInit() {
        this.setEstatusColaborador();
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Número de nómina',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nomina'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Nombre',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Apellido paterno',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'apellidopaterno'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Apellido materno',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'apellidomaterno'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Fecha,
                    Titulo: 'Fecha nacimiento',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'fechanacimiento'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'RFC',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'rfc'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'CURP',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'curp'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Teléfono celular',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'telefonocelular',
                    Mask: this.sistemaService.telefonoMask
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Email personal',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'emailpersonal'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Estatus',
                    DisplayValor: 'nombre',
                    ValorName: 'estatuscolaboradorid',
                    Opciones: this.SelEstatusColaborador,
                    Propiedad: "estatuscolaboradorid",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    setEstatusColaborador() {
        this.appService.Get("catalogo/estatuscolaborador").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelEstatusColaborador = res.data
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'estatuscolaboradorid');
                if (filtro) {
                    filtro.Opciones = this.SelEstatusColaborador;
                }
            }
        });
    }


    SetDatos(data: any) {
        this.dataTable = data;
    }

    Formulario(accionid: number, id: number = 0) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Agregar";
                break;
            case 2:
                accion = "Ver";
                break;
            case 3:
                accion = "Editar";
                break;
        }
        this.cargarContenedorFormulario({accionid: accionid, accion: accion, id: id});
    }

    cargarContenedorFormulario(data: {accionid: number, accion: string, id: number}) {
        this.consulta = true;
        this.containerFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ColaboradorFormComponent);
        var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.id = data.id;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        });
    }

    DescargarLayout() {
        this.appService.PostGetFile("configuracionrh/colaborador/layout", {})
    }

    cargarContenedorLayout() {
        this.consulta = true;
        this.containerFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ColaboradorLayoutComponent);
        var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
        ref.instance.cerrarImportacion.subscribe((nuevo: boolean) => {
            if (nuevo) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
            this.consulta = false;
            ref.destroy();
        });
    }

    Eliminar(e: Colaborador) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'El registro de usuario y profesor se deberán eliminar desde su modulo correspondiente.<br>¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/colaborador/" + e.colaboradorid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

}
